import apiUrl from "../../../constants";
import axios from "axios";
import iptrackerdetails from '../../../iptrackerdetails'

import Paginate from "vuejs-paginate";
import CryptoJS from 'crypto-js';
import {
  Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';

export default {
  name: "approle",
  components: {
    Paginate,
    VueElementLoading
  },
  data: function() {
    return {
      modalShow: false,
      updaterolemodal: false,
      editrolemodal: false,
      addrolemodal: false,
      roleaction: "",
      iptrackData:'',
      listRoleData: [],
      listPermissionData: [],
      permissionid: [],
      localuserid:'',
      pageno: 0,
      pagecount: 0,
      rolename: "",
      searchrolename: (window.localStorage.getItem("LSRole")) ? (window.localStorage.getItem("LSRole")) : "",
      weightage: "",
      is_active:'true',
      perm_id: [],
      roleid: "",
      devicetype: '',
      isLoading: false,
      resultCount: '',
      incrementResultCount: '',
      checkedPerm_Id: [],
      projectid: [],
      listProjectData: [],
      listUserTypeData: [],
      selected: '',
      usertypeid:'',
      changestatus: '',
      description : ''
    };
  },

  created: function() {

  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail
    this.localuserid = userdetail.userid;
    this.localusername = userdetail.username;
    this.getRoleData();
    this.getProjectData();
    this.getUserTypeData();
  },

  methods: {
    addNewRole() {
      this.roleid = "";
      this.rolename = "";
      this.description = "";
      this.projectid = [];
      this.usertypeid = "";
      this.devicetype= "";
      this.weightage= "";
      this.is_active = 'true';
      this.checkedPerm_Id = [];
      this.roleaction = "add";
      this.addrolemodal = true;
      this.$validator.reset();
      this.errors.clear();
    },

    closeAddRoleModal() {
      $("#approleform").trigger("reset");
      this.addrolemodal = false;
      this.$validator.reset();
      this.errors.clear();
    },

    closeStatusRoleModal() {
        this.modalShow = false
    },

    resetSearch(){
      this.searchrolename = "";
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      window.localStorage.removeItem("LSRole")
      this.getRoleData();
    },

    resetform() {
      this.roleid = "";
      this.rolename = "";
      this.description = "";
      this.projectid=[];
      this.usertypeid = "";
      this.devicetype= "";
      this.weightage= "";
      this.is_active= "true";
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.getRoleData();
    },

    getRoleData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        offset: this.pageno,
        limit: 10,
        rolename: this.searchrolename,
        roletype: 2
        });
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "roleMaster",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }

      }).then(
        result => {
          this.listRoleData = result.data.rows;
          this.isLoading = false;
          let totalRows = result.data.count;
          this.resultCount = result.data.count;
          this.incrementResultCount = result.data.count + 1;
          this.weightage=this.incrementResultCount;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    searchRoleData(){
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getRoleDatabySearch();
    },

    getRoleDatabySearch() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      window.localStorage.setItem("LSRole",this.searchrolename)
      this.input = ({
        offset: this.pageno,
        limit: 10,
        rolename: this.searchrolename,
        roletype: 2
        });
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "roleMaster",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }

      }).then(
        result => {
          this.listRoleData = result.data.rows;
          this.isLoading = false;
          let totalRows = result.data.count;
          this.resultCount = result.data.count;
          this.incrementResultCount = result.data.count + 1;
          this.weightage=this.incrementResultCount;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }

        },
        error => {
          console.error(error);
        }
      );
    },

    saveRole(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      if(this.roletype == 1){ this.projectid = []; this.usertypeid = 0; }

      this.input = ({
        rolename: this.rolename.trim(),
        permissionid: this.checkedPerm_Id,
        projectid: this.projectid,
        usertypeid: this.usertypeid,
        is_active: this.is_active,
        roletype: 2,
        createdby:this.localusername,
        description : this.description
      })
      axios({
          method: "POST",
          'url': apiUrl.api_url + "SubmitRoleData",
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
          if (response.data.msg == 200) {
            this.$alertify.success("Application Role Created Successfully");
            this.addrolemodal = false;
            event.target.reset();
            this.resetform();
          } else if (response.data.msg == 209) {
            this.$alertify.error("Application Role Already Exist");
            //this.addrolemodal = false;
          } else if (response.data.msg == 400) {
            this.$alertify.error("Failed");
            this.addrolemodal = false;
            this.resetform();
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'Save Role',this.$route.path,this.input,response.data);

        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getRoleRowData(data, maxWeightage) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      if(data.weightage > maxWeightage){
        maxWeightage = data.weightage;
      }
      this.$validator.reset();
      this.errors.clear();
      this.roleaction = "edit";
      this.addrolemodal = true;
      this.roleid = data.roleid;
      this.rolename = data.rolename;
      this.description = data.description;
      this.is_active = data.is_active;
      this.checkedPerm_Id = [];
      this.projectid = data.projectid;
      this.usertypeid = data.usertypeid;
      this.weightage = data.weightage;
      this.incrementResultCount = maxWeightage;
    },

    editRole(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var permissionid = this.checkedPerm_Id.map(Number);

      this.input = ({
        rolename: this.rolename.trim(),
        roleid: this.roleid,
        permissionid: permissionid,
        projectid: this.projectid,
        usertypeid: this.usertypeid,
        is_active: this.is_active,
        weightage: this.weightage,
        roletype: 2,
        modifiedby: this.localusername,
        description : this.description
      })
      axios({
          method: "POST",
          url: apiUrl.api_url + "UpdateRole",
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
          if (response.data.msg == 200) {
            this.$alertify.success("Application Role updated successfully");
            this.addrolemodal = false;
            this.rolename = '';
            this.description = '';
            event.target.reset();
            this.resetform();
          }else if (response.data.msg == 209) {
            this.$alertify.error("Application role already exist");
            //this.addrolemodal = false;
          }else {
            this.$alertify.error("Application Role failed to update");
            this.addrolemodal = false;
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'Update Role',this.$route.path,this.input,response.data);

        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    //to get project list
    getProjectData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        projectname: ""
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getprojectlist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listProjectData = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },

    //to get User Type list
    getUserTypeData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        usertypename: ""
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getusertypelist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listUserTypeData = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getRoleData();
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          if(this.roleid!=undefined && this.roleid!=""){
            this.editRole(event);
          }else{
            this.saveRole(event);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    //to get target id in active/inactive modal
    getStatusRowData(data) {
        this.Statusaction   = 'add'
        this.modalShow      = true
        this.roleid         = data.roleid
        this.is_active      = data.is_active
        if (data.is_active == true) {
            this.changestatus = 'De-Activate'
        } else {
            this.changestatus = 'Activate'
        }
    },

    //for active/inactive modal
    changeRoleStatus() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr     = userToken.replace(/"/g, '');
      let reqpayload = {
        'roleid': this.roleid,
        'is_active': this.is_active,
      }

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'UpdateStatus',
          'data': {
              'roleid': this.roleid,
              'is_active': this.is_active,
          },
          headers: {
              'Authorization': 'Bearer ' + myStr
          }
      })
      .then((response) => {
          if (response.data.errorCode == 0) {
              this.$alertify.success(response.data.msg);
              this.addrolemodal = false
              this.getRoleData()
          } else if (response.data.errorCode == -1) {
              this.$alertify.error(response.data.msg)
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'Status Update Application Roles',this.$route.path,reqpayload,response.data);

      })
      .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/approle/approle.component.js